module.exports = __webpack_public_path__ + "img/text-italic-active.dc401722.svg";